<template>
    <div class="animation-logo-wrapper">
        <div class="overlay"></div>

        <bc-retail-logo />
    </div>
</template>

<script>
    export default {
        mounted() {
            setTimeout(() => {
                axios.post('api/site-has-been-visited')
            }, 3500)
        }
    }
</script>
